import { LangProvider } from "./i18n";
import { HomePage } from "./pages/HomePage";
import "./index.css";

export function App() {
  return (
    <LangProvider>
      <HomePage />
    </LangProvider>
  );
}

export default App;
